import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

import notificationsReducer from "./notificationsSlice";
import socialReducer from "./socialSlice";
import cartReducer from "./cartSlice";
import commercePartnersReducer from "./commercePartnersSlice";
import merchantReducer from "./merchantSlice";
import subscriptionReducer from "./subscriptionSlice"; // ← add this import

import productsReducer from "./productsSlice";
import productOrdersReducer from "./productsOrderSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
        notifications: notificationsReducer,
            social: socialReducer,
  commercePartners: commercePartnersReducer,
      merchant: merchantReducer,
      subscription: subscriptionReducer, 

products: productsReducer,
productOrders: productOrdersReducer,
     cart: cartReducer,



  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;